var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 5C5.47989 5 4.62145 5.35558 3.98851 5.98851C3.35558 6.62145 3 7.47989 3 8.375V19.625C3 20.5201 3.35558 21.3785 3.98851 22.0115C4.62145 22.6444 5.47989 23 6.375 23H21.225C22.1201 23 22.9785 22.6444 23.6115 22.0115C24.2444 21.3785 24.6 20.5201 24.6 19.625V8.375C24.6 7.47989 24.2444 6.62145 23.6115 5.98851C22.9785 5.35558 22.1201 5 21.225 5H6.375ZM10.2 10.6259C10.2001 10.4704 10.2405 10.3176 10.3172 10.1823C10.3939 10.0471 10.5044 9.93404 10.6378 9.85419C10.7712 9.77433 10.9231 9.73041 11.0785 9.7267C11.234 9.72298 11.3877 9.75961 11.5248 9.833L17.8248 13.208C17.9683 13.2849 18.0883 13.3993 18.172 13.539C18.2557 13.6787 18.2998 13.8385 18.2998 14.0013C18.2998 14.1642 18.2557 14.324 18.172 14.4637C18.0883 14.6034 17.9683 14.7178 17.8248 14.7947L11.5248 18.1697C11.3876 18.2432 11.2337 18.2798 11.0781 18.276C10.9225 18.2722 10.7705 18.2281 10.637 18.1481C10.5036 18.068 10.3931 17.9547 10.3165 17.8192C10.2399 17.6837 10.1998 17.5306 10.2 17.375V10.6259Z",
    fill: "#ADADAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoIcon);
export default __webpack_public_path__ + "static/media/video_icon.cd1a8ae91834ee10286e6486d83659c7.svg";
export { ForwardRef as ReactComponent };